import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const SubscriptionContext = createContext(null);

export function SubscriptionProvider({ children }) {
  const { user } = useAuth();
  const [sub, setSub] = useState(null);
  const [plans, setPlans] = useState([]);
  const [paywallOpen, setPaywallOpen] = useState(false);

  const refreshSub = useCallback(async () => {
    if (!user) { setSub(null); return; }
    try {
      const { data } = await api.get("/subscription/me");
      setSub(data);
    } catch { setSub({ is_pro: false, status: "none" }); }
  }, [user]);

  const loadPlans = useCallback(async () => {
    try {
      const { data } = await api.get("/payments/plans");
      setPlans(data.plans);
    } catch { /* ignore */ }
  }, []);

  useEffect(() => { refreshSub(); }, [refreshSub]);
  useEffect(() => { loadPlans(); }, [loadPlans]);

  const isPro = !!sub?.is_pro;
  const openPaywall = useCallback(() => setPaywallOpen(true), []);
  const closePaywall = useCallback(() => setPaywallOpen(false), []);

  return (
    <SubscriptionContext.Provider
      value={{ sub, isPro, plans, refreshSub, paywallOpen, openPaywall, closePaywall }}
    >
      {children}
    </SubscriptionContext.Provider>
  );
}

export function useSubscription() {
  const ctx = useContext(SubscriptionContext);
  if (!ctx) throw new Error("useSubscription must be used within SubscriptionProvider");
  return ctx;
}
